import script from "./Stats.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stats.vue?vue&type=script&lang=ts&setup=true"

import "./Stats.vue?vue&type=style&index=0&id=37c907c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c907c8"]])

export default __exports__